/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import PostContentLink from 'app/components/common/PostContentLink.jsx';
import { Breakpoint } from 'react-socks';

class PostContentTitle extends React.Component {
    render() {
        return (
            <div className="curate-item-title">
                <Breakpoint desktop only>
                    <div className="item-title-text item-headline">
                        {this.props.item.item.title}
                    </div>
                    <PostContentLink item={this.props.item.item}/>
                </Breakpoint>
                <Breakpoint mobile only>
                    <div className="item-title-text item-headline mobile">
                        <PostContentLink content={this.props.item.item.title} item={this.props.item.item}/>
                    </div>
                </Breakpoint>
            </div>
        );
    }

};

PostContentTitle.propTypes = {
    item: PropTypes.object
};

PostContentTitle.defaultProps = {
    item: {}
};

export default PostContentTitle;
